// src/pages/StravaPage.tsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const STRAVA_CLIENT_ID = "166397";
const STRAVA_CLIENT_SECRET = "6ee63069f5429739304c9603ef202773c9cfa5ff";
const YOUR_STRAVA_ATHLETE_ID = "166397"; // Replace with your own

const StravaPage = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (!code) return;

    const exchangeToken = async () => {
      try {
        const response = await fetch("https://www.strava.com/oauth/token", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            client_id: STRAVA_CLIENT_ID,
            client_secret: STRAVA_CLIENT_SECRET,
            code,
            grant_type: "authorization_code",
          }),
        });

        const data = await response.json();

        if (!data.access_token || !data.athlete) {
          setErrorMessage("Could not retrieve access token or athlete info.");
          return;
        }

        // Check if it's your own account (since Strava only allows 1 user in dev mode)
        if (data.athlete.id.toString() !== YOUR_STRAVA_ATHLETE_ID) {
          setErrorMessage(
            "🚧 Strava sync is currently in testing and only available to the developer."
          );
          return;
        }

        localStorage.setItem("stravaAccessToken", data.access_token);
        localStorage.setItem("stravaExpiresAt", data.expires_at.toString());

        navigate("/strava-editor");
      } catch (err) {
        console.error("❌ Token exchange failed", err);
        setErrorMessage("Something went wrong connecting to Strava.");
      }
    };

    exchangeToken();
  }, [navigate]);

  return (
    <div style={{ padding: "2rem" }}>
      <p>Connecting to Strava...</p>
      {errorMessage && (
        <div
          style={{
            marginTop: "20px",
            padding: "15px",
            backgroundColor: "#ffe0e0",
            border: "1px solid #ff6666",
            borderRadius: "5px",
            color: "#900",
          }}
        >
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default StravaPage;
